import { useQuery } from '@apollo/client';
import React from 'react';
import { OneClickLoader } from '../../components/common/styled';
import { initApolloClient } from '../../lib/ApolloSchema/apolloUtils';
import { GET_APOLLO_STATE } from '../../lib/Graphql/getApolloState';
import { LOADING_INDICATOR_ARIA_LABEL, LOADING_INDICATOR_TESTID } from './constants';
export var LoadingIndicator = function LoadingIndicator() {
  var client = initApolloClient();
  var _useQuery = useQuery(GET_APOLLO_STATE, {
      client: client
    }),
    ApolloState = _useQuery.data;
  var isPageLoaded = ApolloState && ApolloState.uiData.isLoaded;
  return !isPageLoaded ? /*#__PURE__*/React.createElement("div", {
    "aria-live": 'assertive',
    role: 'alertdialog',
    "aria-label": LOADING_INDICATOR_ARIA_LABEL
  }, /*#__PURE__*/React.createElement(OneClickLoader, {
    "data-test": LOADING_INDICATOR_TESTID,
    size: "large"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/modules/LoadingIndicator/index.js
// module id = 4174
// module chunks = 11